import { render } from "./OpenIndicator.vue?vue&type=template&id=545c4ede"
const script = {}

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__